import React from 'react';
import { useStoreId } from '@thd-nucleus/experience-context';
import { useDataModel } from '@thd-nucleus/data-sources';

const useRelatedSearchData = ({
  itemId, navParam, storeId: resolvedStoreId, searchDataProps, keyword = null
}) => {
  const storeId = useStoreId();
  const fallbackStoreId = resolvedStoreId || storeId;
  const propsData = searchDataProps?.searchModel?.relatedResults?.relatedKeywords;
  const hasPropsData = propsData && propsData.length > 0;

  // Determine which model to use and whether to skip
  // If keyword exists, it's a search page - use searchModel
  const shouldUseSearchModel = !hasPropsData && keyword && !navParam && !itemId;
  const shouldUseRelatedSearchModel = !hasPropsData && (navParam || itemId);
  const shouldSkip = hasPropsData || (!shouldUseSearchModel && !shouldUseRelatedSearchModel);

  // Choose model and variables based on the situation
  const modelName = shouldUseSearchModel ? 'searchModel' : 'relatedSearchModel';
  const modelVariables = shouldUseSearchModel
    ? { keyword, storeId: fallbackStoreId }
    : { ...(itemId && { itemId }), ...(navParam && { navParam }), storeId: fallbackStoreId };

  const { data, error, loading } = useDataModel(modelName, {
    variables: modelVariables,
    skip: shouldSkip,
  });

  // Extract data from the appropriate model response
  const dataFromApi = shouldUseSearchModel
    ? data?.searchModel?.relatedResults?.relatedKeywords || []
    : data?.relatedSearchModel?.relatedSearch || [];

  const relatedKeywords = hasPropsData ? propsData : dataFromApi;

  return { relatedKeywords, loading, error };
};

export { useRelatedSearchData };
